import React from "react";

const SayHelloBtn = ({ theme }) => (
  <button
    className={`${
      theme === "dark"
        ? "bg-gradient-to-r from-[#1055EA] to-darkLineColor"
        : "bg-gradient-to-r from-lightTextDesignColor to-darkLineColor"
    } hover:bg-gradient-to-l text-white text-2xl px-8 py-4 rounded-lg text-center w-52 transition-hover duration-300 cursor-pointer`}
  >
    Contact Me
  </button>
);

export default SayHelloBtn;
